import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchMerchants: (): NetworkPayload => ({
    url: "merchants/",
    options: {
      method: "GET",
    },
  }),
};
